import {
  QuestionSourceConnector,
  QuestionSource,
  CreateQuestionSource,
  QuestionSourceMin,
  QuestionSourceAccountInfo,
  UpdateQuestionSource,
  ExternalAuthorizationId,
  QuestionSourceId,
} from "platformed-client/types";
import {invalidateQueries, q} from "../../state";
import {platformedClient} from "..";

export async function listConnectors(): Promise<QuestionSourceConnector[]> {
  return await platformedClient.internalRequest(
    "get",
    `/region/{region}/api/vendor_toolkit/question_source_connectors`,
    {},
  );
}

export async function getConnector(connectorId: string): Promise<QuestionSourceConnector> {
  return await platformedClient.internalRequest(
    "get",
    `/region/{region}/api/vendor_toolkit/question_source_connectors/{question_source_connector_id}`,
    {path: {question_source_connector_id: connectorId}},
  );
}

export async function getAccountInfo(
  connectorId: string,
  externalAuthorizationId: ExternalAuthorizationId,
): Promise<QuestionSourceAccountInfo> {
  return await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/question_source_connectors/{question_source_connector_id}/account_info`,
    {body: externalAuthorizationId, path: {question_source_connector_id: connectorId}},
  );
}

export async function list(): Promise<QuestionSourceMin[]> {
  return await platformedClient.internalRequest("get", `/region/{region}/api/vendor_toolkit/question_sources`, {});
}

export async function get(connectionId: QuestionSourceId): Promise<QuestionSource> {
  return await platformedClient.internalRequest(
    "get",
    `/region/{region}/api/vendor_toolkit/question_sources/{question_source_id}`,
    {path: {question_source_id: connectionId}},
  );
}

export async function create(connection: CreateQuestionSource): Promise<QuestionSource> {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/vendor_toolkit/question_sources`, {
    body: connection,
  });
  await invalidateQueries([q.vendorToolkit.questionSources.filter()]);
  return res;
}

export async function updateName(connectionId: QuestionSourceId, name: string) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/question_sources/{question_source_id}/name`,
    {body: name, path: {question_source_id: connectionId}},
  );
  await invalidateQueries([
    q.vendorToolkit.questionSource.filter(connectionId),
    q.vendorToolkit.questionSources.filter(),
  ]);
  return res;
}
export async function update(connectionId: QuestionSourceId, update: UpdateQuestionSource) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/question_sources/{question_source_id}`,
    {body: update, path: {question_source_id: connectionId}},
  );
  await invalidateQueries([
    q.vendorToolkit.questionSource.filter(connectionId),
    q.vendorToolkit.questionSources.filter(),
  ]);
  return res;
}
